import { Component, OnDestroy, OnInit } from '@angular/core';


import { MainLayoutComponent } from 'src/app/shared/components/main-layout/main-layout.component';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-project-details-submitted',
  standalone: true,
  imports: [
    MainLayoutComponent
],
  templateUrl: './project-details-submitted.component.html'
})
export class ProjectDetailsSubmittedComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  commentsSubmitted = false;
  constructor(
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    const routeSub = this.route.data.subscribe((data) => {
      this.commentsSubmitted = !!data?.['commentsSubmitted'];
    });
    this.subscriptions.add(routeSub);
  }

  ngOnDestroy(): void {
    if(this.subscriptions) this.subscriptions.unsubscribe();
  }
}
